<template>
  <el-tooltip
      class="flex-grow"
      content="Open device's Alarm Desktop"
      placement="bottom">
    <el-link
        type="primary"
        target="_blank"
        :underline="false"
        :href="url">
      <i class="el-icon-link" />
    </el-link>
  </el-tooltip>
</template>

<script>
export default {
  name: "AlarmDesktopLink",
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped></style>
